import { action } from 'typesafe-actions';
import { SchoolSettingsTypes, SchoolSettingsInterface } from './types';

// Get School Settings
export const getSchoolSettingsRequest = (payload: object) =>
  action(SchoolSettingsTypes.GET_SCHOOL_SETTINGS_REQUEST, payload);
export const getSchoolSettingsSuccess = (payload: {
  schoolSettingsData: SchoolSettingsInterface;
}) => action(SchoolSettingsTypes.GET_SCHOOL_SETTINGS_SUCCESS, payload);
export const getSchoolSettingsFailure = () =>
  action(SchoolSettingsTypes.GET_SCHOOL_SETTINGS_FAILURE);

// Update School Settings
export const updateSchoolSettingsRequest = (payload: object) =>
  action(SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_REQUEST, payload);
export const updateSchoolSettingsSuccess = (payload: {
  schoolSettingsData: SchoolSettingsInterface;
}) => action(SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_SUCCESS, payload);
export const updateSchoolSettingsFailure = () =>
  action(SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_FAILURE);

// Update School Settings Individual
export const updateSchoolSettingsIndividualRequest = (payload: Array<object>) =>
  action(
    SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_REQUEST,
    payload,
  );
export const updateSchoolSettingsIndividualSuccess = (payload: {
  schoolSettingsData: SchoolSettingsInterface;
}) =>
  action(
    SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_SUCCESS,
    payload,
  );
export const updateSchoolSettingsIndividualFailure = () =>
  action(SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_FAILURE);
